import { PartnerAlimonyStoreService } from '@hb/modules/financial-obligations/partner-alimony/partner-alimony-store.service';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'partner-alimony-amount',
    imports: [ApAmountInputComponent, CoApplicantPipe, ApContentPipe, ReactiveFormsModule, AdditionalInfoComponent, NextButtonComponent],
    templateUrl: './partner-alimony-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PartnerAlimonyStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PARTNER_ALIMONY_AMOUNT }
    ]
})
export class PartnerAlimonyAmountComponent extends GlobalInjectComponent<PartnerAlimonyStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PartnerAlimonyStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setAmount(amount));
    }
}
